export default __webpack_public_path__ + "da775cb4b03efe7cb3f1180668b84836.png";